import React from 'react';
import _ from 'lodash';
import { Card } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-fetching-library';

import { getOrdersAction } from '../../services/request';
import { useSettings, useGetSeasonConfig } from '../../services/hooks';
import Page from '../../components/Page';
import {
  OrderList,
  OrderSidebar,
  OrderDetails
} from '../../sections/employee/order';
import { setAllowAutoOrderUpdate } from '../../services/redux-actions';
import { OLOrderList } from '../../sections/employee/order/OLOrderList';
import { ZSOrderList } from '../../sections/employee/order/ZSOrderList';
import { PLOrderList } from '../../sections/employee/order/PLOrderList';
import { WROrderList } from '../../sections/employee/order/WROrderList';
export const Order = () => {
  const dispatch = useDispatch();
  const { allowAutoOrderUpdate, season, module } = useSelector(
    state => state.app
  );
  const { orderFilters, orderSearchFields } = useGetSeasonConfig(
    module,
    season
  );
  const [pageSettings, setPageSettings] = React.useState({
    page: 1,
    pageSize: 100,
    search: null,
    sortFields: ['-id']
  });
  const { loading, payload, error, query } = useQuery(
    getOrdersAction(
      pageSettings.page,
      pageSettings.pageSize,
      pageSettings.search,
      orderFilters,
      orderSearchFields,
      pageSettings.sortFields
    )
  );
  const [orders, setOrders] = React.useState([]);
  const [selectedOrdersIds, setSelectedOrdersIds] = React.useState([]);
  const { themeStretch } = useSettings();
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [openCompose, setOpenCompose] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [idList, setIdList] = React.useState([]);
  const [ordersDataForMessages, setOrdersDataForMessages] = React.useState([]);

  React.useEffect(() => {
    dispatch(setAllowAutoOrderUpdate(true));
  }, []);
  React.useEffect(() => {
    query(
      pageSettings.page,
      pageSettings.pageSize,
      pageSettings.search,
      orderFilters,
      orderSearchFields,
      pageSettings.sortFields
    );
  }, [orderFilters, orderSearchFields]);

  React.useEffect(() => {
    if (!error && !loading) {
      setIdList(payload.id_list);
      setOrdersDataForMessages(payload.orders_data_for_messages);
      setCount(payload.count);
      setOrders(payload.results);
    }
  }, [loading]);

  React.useEffect(() => {
    const updateOrdersInterval = setInterval(() => {
      if (allowAutoOrderUpdate) {
        query(
          pageSettings.page,
          pageSettings.pageSize,
          pageSettings.search,
          orderFilters,
          orderSearchFields,
          pageSettings.sortFields
        );
      }
    }, 30 * 1000);

    return () => clearInterval(updateOrdersInterval);
  }, [query, allowAutoOrderUpdate]);

  const queryCallback = (pageD, pageSize, search = null, sortFields = null) => {
    const page = pageD + 1;
    setPageSettings({ page, pageSize, search, sortFields });
    query(
      pageSettings.page,
      pageSettings.pageSize,
      pageSettings.search,
      orderFilters,
      orderSearchFields,
      pageSettings.sortFields
    );
  };

  const updateOrders = newOrder => setOrders(prev => prev.map(order => (order.id === newOrder.id ? newOrder : order)));
  const addOrder = newOrder => setOrders(prev => [newOrder, ...prev]);
  const removeOrderFromOrders = orderId => setOrders(prev => prev.filter(order => order.id !== orderId));

  return (
    <Page title="Zamówienia">
      <Card sx={{ height: { md: '72vh' }, display: { md: 'flex' } }}>
        {!hideSidebar && (
          <OrderSidebar
            orderListLoading={loading}
            isOpenSidebar={openSidebar}
            onCloseSidebar={() => setOpenSidebar(false)}
            onOpenCompose={() => setOpenCompose(true)}
            idList={idList}
            setIdList={setIdList}
            ordersDataForMessages={ordersDataForMessages}
            refreshOrders={() => query(
              pageSettings.page,
              pageSettings.pageSize,
              pageSettings.search,
              orderFilters,
              orderSearchFields,
              pageSettings.sortFields
            )
            }
            selectedOrdersIds={selectedOrdersIds}
          />
        )}
        {module == 'obozy' ? (
          <OLOrderList
            hideSidebar={() => setHideSidebar(!hideSidebar)}
            onOpenSidebar={() => setOpenSidebar(true)}
            count={count}
            queryCallback={queryCallback}
            loading={loading}
            orders={orders}
            updateOrders={updateOrders}
            addOrder={addOrder}
            removeOrderFromOrders={removeOrderFromOrders}
            refreshOrders={() => query(
              pageSettings.page,
              pageSettings.pageSize,
              pageSettings.search,
              orderFilters,
              orderSearchFields,
              pageSettings.sortFields
            )
            }
            selectedOrdersIds={selectedOrdersIds}
            setSelectedOrdersIds={setSelectedOrdersIds}
          />
        ) : module == 'zielone_szkoly' ? (
          <ZSOrderList
            hideSidebar={() => setHideSidebar(!hideSidebar)}
            onOpenSidebar={() => setOpenSidebar(true)}
            count={count}
            queryCallback={queryCallback}
            loading={loading}
            orders={orders}
            updateOrders={updateOrders}
            addOrder={addOrder}
            removeOrderFromOrders={removeOrderFromOrders}
            refreshOrders={() => query(
              pageSettings.page,
              pageSettings.pageSize,
              pageSettings.search,
              orderFilters,
              orderSearchFields,
              pageSettings.sortFields
            )
            }
            selectedOrdersIds={selectedOrdersIds}
            setSelectedOrdersIds={setSelectedOrdersIds}
          />
        ) : module == 'polkolonie' ? (
          <PLOrderList
            hideSidebar={() => setHideSidebar(!hideSidebar)}
            onOpenSidebar={() => setOpenSidebar(true)}
            count={count}
            queryCallback={queryCallback}
            loading={loading}
            orders={orders}
            updateOrders={updateOrders}
            addOrder={addOrder}
            removeOrderFromOrders={removeOrderFromOrders}
            refreshOrders={() => query(
              pageSettings.page,
              pageSettings.pageSize,
              pageSettings.search,
              orderFilters,
              orderSearchFields,
              pageSettings.sortFields
            )
            }
            selectedOrdersIds={selectedOrdersIds}
            setSelectedOrdersIds={setSelectedOrdersIds}
          />
        ) : module == 'wyjazdy_rodzinne' ? (
          <WROrderList
            hideSidebar={() => setHideSidebar(!hideSidebar)}
            onOpenSidebar={() => setOpenSidebar(true)}
            count={count}
            queryCallback={queryCallback}
            loading={loading}
            orders={orders}
            updateOrders={updateOrders}
            addOrder={addOrder}
            removeOrderFromOrders={removeOrderFromOrders}
            refreshOrders={() => query(
              pageSettings.page,
              pageSettings.pageSize,
              pageSettings.search,
              orderFilters,
              orderSearchFields,
              pageSettings.sortFields
            )
            }
            selectedOrdersIds={selectedOrdersIds}
            setSelectedOrdersIds={setSelectedOrdersIds}
          />
        ) : null}
        <OrderDetails
          isOpenCompose={openCompose}
          onCloseCompose={() => setOpenCompose(false)}
          updateOrders={updateOrders}
          removeOrderFromOrders={removeOrderFromOrders}
        />
      </Card>
    </Page>
  );
};
